module.exports = __webpack_public_path__ + "img/MELA_Neutrophils.17db70d5.png";